import React from "react";
import * as aor from "react-admin";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import TextField from "@material-ui/core/TextField";
import { DialogTitle } from "@material-ui/core";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Tooltip from "@material-ui/core/Tooltip";
import TranslatedText from "./TranslatedText";
import Create from "@material-ui/icons/Create";
import AutoCompleteInput from "../components/AutoCompleteInput";
import myRestClient from "../common/restClient";
import tccStyles from "../common/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { POLICY_INSTALLATIONS } from "../common/rolesManagement";
import { InstallationEventStatus } from "../common/statuses";
import { getConfig } from "../common/utilities";
import { OperationType } from "../common/operationTypes";
import InputAdornment from "@material-ui/core/InputAdornment";
import HelpIcon from "@material-ui/icons/Help";

const customerOptions = {
    resource: "customers",
    display: "name",
    label: "Cliente",
    isMulti: false
};

class CustomerTransfer extends React.Component {
    state = {
        open: false,
        customer_id: null,
        url_name: null,
        company_name: null,
        loading: false,
        operation: [],
        urlTransferOp: [],
        is_operational: null,
        has_operation_running: null
    };

    componentDidMount() {
        this.setState({
            url_name: this.props.record.access_url,
            customer_id: this.props.record.customer_id,
            installationStatus: this.props.record.status,
            installationLocked: this.props.record.locked
        });

        myRestClient("GET_ONE", "companies", {
            id: this.props.record.company_id
        }).then(
            result => {
                this.setState({
                    company_name: result.data.name
                });
            },
            error => {
                console.log(error);
            }
        );

        getConfig().then(result => {
            this.setState({ portal_locked: result.portal_lock });
        });

        if (this.props.record.installation_type_id) {
            let params = {
                pagination: { page: 1, perPage: 10000 },
                sort: { field: "name", order: "asc" },
                filter: {
                    installation_type_id: this.props.record.installation_type_id
                },
                filter_type: [
                    OperationType.CustomerTransfer,
                    OperationType.UrlTransfer
                ]
            };

            myRestClient("GET_LIST", "operations", params).then(
                result => {
                    const customerTransferOps = result.data
                        .filter(
                            item =>
                                item.operation_type_name ===
                                OperationType.CustomerTransfer
                        )
                        .map(item => ({
                            id: item.operation_type_name,
                            name: item.operation_type_description
                        }));

                    const urlTransferOps = result.data
                        .filter(
                            item =>
                                item.operation_type_name ===
                                OperationType.UrlTransfer
                        )
                        .map(item => ({
                            id: item.operation_type_name,
                            name: item.operation_type_description
                        }));

                    this.setState({
                        operation: customerTransferOps,
                        urlTransferOp: urlTransferOps
                    });
                },
                error => {
                    return error;
                }
            );
        }

        const params = {
            filter: { export: true },
            pagination: { page: 1, perPage: 1000 },
            sort: { field: "customer_id", order: "asc" },
            id_inst: [this.props.record.id],
            infoTransfer: true
        };

        myRestClient("GET_LIST", "installations", params).then(
            result => {
                this.setState({
                    is_operational: result.data[0].is_operational,
                    has_operation_running: result.data[0].has_operation_running
                });
            },
            error => {
                return error;
            }
        );
    }

    handleClickOpen = () => {
        this.setState({ open: true, message: "" });
    };

    handleClose = () => {
        this.setState({
            open: false,
            customer_id: null,
            url_name: this.props.record.access_url
        });
    };

    handleCloseSnackBar = () => {
        this.setState({ showSnackBar: false });
    };

    handleOk = () => {
        if (
            (this.props.record.customer_id === this.state.customer_id &&
                this.props.record.access_url === this.state.url_name) ||
            (this.props.record.customer_id === this.state.customer_id &&
                this.state.url_name === "") ||
            (this.state.customer_id === "" &&
                this.props.record.access_url === this.state.url_name)
        ) {
            this.setState({
                error: true,
                showSnackBar: true,
                message:
                    "Selezionare un cliente e/o un Access url differenti da quelli attuali",
                loading: false
            });
        } else {
            const query = {
                id: this.props.record.id,
                data: {
                    tmp_customer_id: this.state.customer_id,
                    tmp_company_id: this.state.company_id,
                    tmp_access_url: this.state.url_name
                        ? this.state.url_name
                        : ""
                }
            };
            this.setState({
                loading: true
            });
            myRestClient("UPDATE_NO_PREV", "installations", query).then(
                result => {
                    this.setState({
                        open: false,
                        showSnackBar: true,
                        message: "Inviata richiesta aggiornamento",
                        error: false,
                        customer_id: null,
                        url_name: null,
                        loading: false
                    });
                },
                error => {
                    this.setState({
                        error: true,
                        showSnackBar: true,
                        message: error.message,
                        loading: false
                    });
                }
            );
        }
    };

    onCustomerChanged = value => {
        this.setState({ customer_id: value, message: "" });
    };

    onUrlChanged = value => {
        this.setState({ url_name: value, message: "" });
    };

    myCustomerSelect(props) {
        props.input.value = [props.record.customer_id];
        return (
            <React.Fragment>
                <AutoCompleteInput
                    {...props}
                    onCustomerChanged={this.onCustomerChanged}
                    validate={aor.required()}
                    name="customer_id"
                    component={AutoCompleteInput}
                    {...{
                        options: customerOptions,
                        lazy: false,
                        filter: { company_name: this.state.company_name }
                    }}
                />
                {this.state.urlTransferOp.length > 0 && (
                    <TextField
                        value={this.state.url_name}
                        label="Access url"
                        name="access_url"
                        type="text"
                        margin="normal"
                        autoComplete="off"
                        disabled={false}
                        onChange={value => {
                            this.onUrlChanged(value.currentTarget.value);
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Tooltip
                                        placement="left"
                                        title={
                                            <TranslatedText
                                                resource_name={`resources.installation_types.url_pattern.${this.props.record.installation_type}`}
                                            />
                                        }
                                    >
                                        <HelpIcon
                                            style={{
                                                verticalAlign: "center",
                                                marginLeft: 20,
                                                marginBottom: 3
                                            }}
                                        />
                                    </Tooltip>
                                </InputAdornment>
                            )
                        }}
                    />
                )}
                {this.renderErrorMessage()}
            </React.Fragment>
        );
    }

    renderErrorMessage() {
        return this.state.error === true ? (
            <div>
                <span style={{ color: tccStyles.colors.error }}>
                    {this.state.message === "Validation failed" ? (
                        "Errore nella validazione dei parametri inseriti"
                    ) : this.state.message.includes(
                          "PATCH installations - AWX start lambda for Update failed installation_id"
                      ) ? (
                        "Errore comunicazione con il cloud"
                    ) : (
                        <TranslatedText resource_name={this.state.message} />
                    )}
                </span>
            </div>
        ) : (
            <div />
        );
    }

    render() {
        const permissions = this.props.permissions;
        return (
            <aor.FormDataConsumer>
                {({ formData }) => {
                    return formData ? (
                        <React.Fragment>
                            <aor.Labeled label="resources.installations.fields.customer_name">
                                <aor.ReferenceField
                                    key={formData.customer_id}
                                    record={formData}
                                    resource="customers"
                                    basePath="/customers"
                                    source="customer_id"
                                    reference="customers"
                                    linkType="show"
                                    allowEmpty
                                >
                                    <aor.TextField source="name" />
                                </aor.ReferenceField>
                            </aor.Labeled>
                            {permissions &&
                                permissions.includes(
                                    POLICY_INSTALLATIONS.TRANSFER
                                ) &&
                                this.state.is_operational &&
                                !this.state.has_operation_running &&
                                this.state.operation.length > 0 &&
                                this.state.installationStatus !==
                                    InstallationEventStatus.pendingDelete &&
                                ((!this.state.installationLocked &&
                                    !this.state.portal_locked) ||
                                    this.props.isAdminRole) && (
                                    <Button
                                        style={{
                                            position: "relative",
                                            top: 24
                                        }}
                                        color="primary"
                                        target="_blank"
                                        onClick={this.handleClickOpen}
                                    >
                                        <Tooltip
                                            title={
                                                <TranslatedText
                                                    resource_name={`resources.installations.actions.customer_transfer`}
                                                />
                                            }
                                        >
                                            <Create />
                                        </Tooltip>
                                    </Button>
                                )}
                            <Dialog
                                style={{
                                    overflow: "visible",
                                    overflowY: "visible"
                                }}
                                disableBackdropClick
                                disableEscapeKeyDown
                                maxWidth="xs"
                                open={this.state.open}
                                onClose={this.handleClose}
                            >
                                <DialogTitle id="form-dialog-title">
                                    <b>
                                        <TranslatedText
                                            resource_name={`resources.installations.actions.customer_transfer`}
                                        />
                                    </b>
                                </DialogTitle>
                                <DialogContent
                                    style={{
                                        overflow: "visible",
                                        overflowY: "visible"
                                    }}
                                >
                                    {this.myCustomerSelect(this.props)}
                                </DialogContent>
                                <DialogActions>
                                    <div
                                        align="center"
                                        style={{
                                            visibility: this.state.loading
                                                ? "visible"
                                                : "hidden"
                                        }}
                                    >
                                        {<CircularProgress />}
                                    </div>
                                    {!this.state.loading && (
                                        <b>
                                            <Button
                                                onClick={this.handleClose}
                                                color="primary"
                                            >
                                                <TranslatedText
                                                    resource_name={
                                                        "ra.actions.cancel"
                                                    }
                                                />
                                            </Button>
                                            <Button
                                                onClick={this.handleOk}
                                                color="primary"
                                            >
                                                <TranslatedText
                                                    resource_name={
                                                        "ra.actions.ok"
                                                    }
                                                />
                                            </Button>
                                        </b>
                                    )}
                                </DialogActions>
                            </Dialog>
                        </React.Fragment>
                    ) : null;
                }}
            </aor.FormDataConsumer>
        );
    }
}

export default CustomerTransfer;



// WEBPACK FOOTER //
// ./src/components/CustomerTransfer.js